import { SupportDeskPaneCollapseButton } from './SupportDeskPaneCollapseButton';

type SupportDeskCollapsedPaneProps = {
  label: string;
  expandLabel: string;
  side: 'start' | 'end';
  onExpand: () => void;
};

export function SupportDeskCollapsedPane({
  label,
  expandLabel,
  side,
  onExpand,
}: SupportDeskCollapsedPaneProps) {
  return (
    <div className="flex h-full min-h-0 flex-col items-center gap-2 px-1 py-2">
      <SupportDeskPaneCollapseButton
        collapsed
        side={side}
        collapseLabel=""
        expandLabel={expandLabel}
        onToggle={onExpand}
      />
      <span
        className={`select-none text-[11px] font-semibold uppercase tracking-wide text-secondary-500 [writing-mode:vertical-rl] ${
          side === 'start' ? 'rotate-180' : ''
        }`}
      >
        {label}
      </span>
    </div>
  );
}
